module.exports = __webpack_public_path__ + "img/product-cupo.9a900f3a.svg";